import React from "react";
import { Mail, Phone, Location } from "../AdminIcons";
const ContactItem = ({ label, icon: Icon, value }) => (
  <div className="flex gap-4">
    <div className="flex w-[25px] shrink-0 items-start justify-center pt-0.5">
      {Icon ? <Icon /> : null}
    </div>
    <div>
      <p className="text-2xl leading-7 text-[#484848]">{label}</p>
      <p className="leading-[23px] text-xl text-[#2D2D2D]">{value}</p>
    </div>
  </div>
);

const StudentProfileInformation = ({
  email = "johndoe23@gmail.com",
  phone = "+9234568902",
  location = "123 Main street, Apt 4B",
  ageGroup = "Grade 4",
  course = "Mental Maths",
  level = "Advanced",
}) => {
  return (
    <section className="rounded-xl border border-[#60555557] bg-white px-6 pb-[73px] pt-6 sm:px-9">
      <h3 className="text-xl font-medium leading-[23px] text-black">Profile Information</h3>

      <div className="mt-4 space-y-6 pl-9">
        <ContactItem label="Email" icon={Mail} value={email} />
        <ContactItem label="Phone" icon={Phone} value={phone} />
        <ContactItem label="Location" icon={Location} value={location} />
      </div>

      <div className="mt-10 space-y-6 pl-9">
        <ContactItem label="Age Group"  value={ageGroup} />
        <ContactItem label="Course"  value={course} />
        <ContactItem label="Level"  value={level} />
      </div>
    </section>
  );
};

export default StudentProfileInformation;
